import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemCompanyProps<TRow extends object = Record<string, unknown>> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

export const MenuItemCompany = <TRow extends object = Record<string, unknown>>(
  props: MenuItemCompanyProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  //#region useMemo

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  const noOptionsAvailable = useMemo(() => {
    return (
      !props?.showItems?.showChildCompanies &&
      !props?.showItems?.showAddChildCompany &&
      !props?.showItems?.showLocations &&
      !props?.showItems?.showEdit &&
      !props?.showItems?.showUnlink &&
      !props?.showItems?.showDelete
    );
  }, [props.showItems]);

  //#endregion useMemo

  // const handleRedirect = () => {
  //   // Example redirect
  //   // window.location.href = `/details/${row.id}`;
  // };

  // const handleOpenModal = () => {
  //   // Trigger modal logic here
  //   // console.log("Open modal for", row);
  //   handleClose();
  // };

  //#region Handlers

  const handleClose = () => {
    props.handleClose();
  };

  const handleDeleteAction = () => {
    props.menuClick(`${menuFor}-delete`, props.row);
    handleClose();
  };

  const handleChildCompaniesAction = () => {
    props.menuClick(`${menuFor}-child-companies`, props.row);
    handleClose();
  };

  const handleLocationsAction = () => {
    props.menuClick(`${menuFor}-locations`, props.row);
    handleClose();
  };

  const handleEditAction = () => {
    props.menuClick(`${menuFor}-edit`, props.row);
    handleClose();
  };

  const handleAddChildCompanyAction = () => {
    props.menuClick(`${menuFor}-add-child`, props.row);
    handleClose();
  };

  //#endregion Handlers

  return (
    <>
      {props?.showItems?.showEdit && (
        <MenuItem onClick={handleEditAction}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Edit")} />
        </MenuItem>
      )}

      {props?.showItems?.showAddChildCompany && (
        <MenuItem onClick={handleAddChildCompanyAction}>
          <ListItemIcon>
            <AddCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Add child company")} />
        </MenuItem>
      )}

      {props?.showItems?.showChildCompanies && (
        <MenuItem onClick={handleChildCompaniesAction}>
          <ListItemIcon>
            <AccountTreeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Child Companies")} />
        </MenuItem>
      )}

      {props?.showItems?.showLocations && (
        <MenuItem onClick={handleLocationsAction}>
          <ListItemIcon>
            <LocationOnIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Locations")} />
        </MenuItem>
      )}

      {(props?.showItems?.showDelete || props?.showItems?.showUnlink) && (
        <MenuItem onClick={handleDeleteAction}>
          <ListItemIcon>
            <DeleteIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Delete")} />
        </MenuItem>
      )}

      {noOptionsAvailable && (
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <InfoIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("No option available")} />
        </MenuItem>
      )}

      {/*<MenuItem onClick={handleRedirect}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <OpenInNewIcon fontSize="small" />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Go to Details" />*/}
      {/*</MenuItem>*/}
      {/*<MenuItem onClick={handleOpenModal}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <EditIcon fontSize="small" />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Open Modal" />*/}
      {/*</MenuItem>*/}
      {/*<MenuItem onClick={handleRemoveAction}>*/}
      {/*  <ListItemIcon>*/}
      {/*    <DeleteIcon fontSize="small" />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Remove" />*/}
      {/*</MenuItem>*/}
    </>
  );
};
